import { Box, Card, Grid, Typography } from '@mui/material'
import React from 'react'
import Charges from './Charges'
import Coverage from './Coverage'

const ChargesAndCoverage = () => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={8} md={6}>
        <Charges/>
      </Grid>
      {/* <Grid item xs={12} sm={4} md={6}>
        <Coverage/>
      </Grid> */}
    </Grid>
  )
}

export default ChargesAndCoverage